import React from 'react';
import PropTypes from 'prop-types';
import Navigation from '../../../Navigation/NavigationContainer';
import Validation from '../../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../../AdvWorkflowStep/AdvWorkflowStepContainer';
import AdvForm from '../../../../CommonComponents/AdvForm';
import { inputTextChanged } from '../../../../Profile/Accounts_react/AccountsUtils';
import InputDollar from '../../../InputDollar/InputDollarView';
import {
  createCustomPropType,
  isNonEmptyString,
  isNumeric,
} from '../../../../../js/app/react/validators';
import { BACKEND_DECUMULATION_GOAL_API } from '../../DecumulationWorkflow.constants';
import InputPercentage from '../../../InputPercentage/InputPercentageView';
import {
  DOLLAR_CONTRIBUTION,
  PERCENTAGE_CONTRIBUTION,
} from '../../../AccountsWorkflow/AccountsWorkflowConstants';
import ContributionPicker from '../../../SharedComponents/ContributionPicker/ContributionPickerView';

const validator = value => () =>
  isNumeric(value) && +value > 0 ? [] : ['Please enter a valid amount'];

const YearlyDistributionView = props => {
  const {
    workflowId,
    branch,
    clientId,
    store,
    distributionStrategyType,
    distributionPercentage,
    distributionDollarAmount,
    doNotSave,
  } = props;

  const valueName =
    distributionStrategyType === 0 ? 'DistributionPercentage' : 'DistributionDollarAmount';

  return (
    <AdvWorkflowStep branch={branch} workflowId={workflowId} id="DecumulationYearlyDistribution">
      <Validation
        workflowId={workflowId}
        validationId={`${BACKEND_DECUMULATION_GOAL_API}.${valueName}`}
      />

      <h2>How much do you want to distribute each year?</h2>

      <AdvForm>
        <ul className="horizontal">
          <li css="position: relative">
            {distributionStrategyType === 0 ? (
              <InputPercentage
                placeholder="Yearly Amount"
                id="adv-yearly-amount"
                isUnder
                className="sm text-center"
                maxLength="256"
                value={distributionPercentage}
                onChange={inputTextChanged(
                  clientId,
                  store(workflowId),
                  `${BACKEND_DECUMULATION_GOAL_API}.DistributionPercentage`,
                )}
              />
            ) : (
              <InputDollar
                placeholder="Yearly Amount"
                id="adv-yearly-amount"
                isUnder
                className="sm text-center"
                value={distributionDollarAmount}
                onChange={inputTextChanged(
                  clientId,
                  store(workflowId),
                  `${BACKEND_DECUMULATION_GOAL_API}.DistributionDollarAmount`,
                )}
              />
            )}

            <ContributionPicker
              contributionType={
                distributionStrategyType === 0 ? PERCENTAGE_CONTRIBUTION : DOLLAR_CONTRIBUTION
              }
              onDollarClick={() => {
                store(workflowId)(
                  {
                    [BACKEND_DECUMULATION_GOAL_API]: {
                      DistributionStrategyType: 1,
                    },
                  },
                  clientId,
                );
              }}
              onPercentClick={() => {
                store(workflowId)(
                  {
                    [BACKEND_DECUMULATION_GOAL_API]: {
                      DistributionStrategyType: 0,
                    },
                  },
                  clientId,
                );
              }}
              style={{ right: -80 }}
            />
          </li>
        </ul>
      </AdvForm>

      <Navigation
        nextIterators={[]}
        dirtyGraphNodes={[]}
        validator={validator(
          distributionStrategyType === 0 ? distributionPercentage : distributionDollarAmount,
        )}
        validationId={`${BACKEND_DECUMULATION_GOAL_API}.${valueName}`}
        workflowId={workflowId}
        backendKey={BACKEND_DECUMULATION_GOAL_API}
        doNotSave={doNotSave}
      />
    </AdvWorkflowStep>
  );
};

YearlyDistributionView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  distributionStrategyType: PropTypes.oneOf([0, 1]).isRequired,
  distributionPercentage: PropTypes.oneOf([PropTypes.string, null]).isRequired,
  distributionDollarAmount: PropTypes.oneOf([PropTypes.string, null]).isRequired,
  doNotSave: PropTypes.bool.isRequired,
};

export default YearlyDistributionView;
